// extracted by mini-css-extract-plugin
module.exports = {"loaderCover":"Pageloader_loaderCover__vcjj3","loader":"Pageloader_loader__B_Std"};